<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17.5" viewBox="0 0 16 17.5">
  <path id="home_FILL1_wght400_GRAD0_opsz24" d="M162,253.5a2.006,2.006,0,0,1-2-2v-9a1.986,1.986,0,0,1,.213-.9,1.918,1.918,0,0,1,.587-.7l6-4.5a2.11,2.11,0,0,1,.575-.3,2,2,0,0,1,1.25,0,2.11,2.11,0,0,1,.575.3l6,4.5a1.918,1.918,0,0,1,.587.7,1.986,1.986,0,0,1,.213.9v9a2.006,2.006,0,0,1-2,2h-4v-7h-4v7Z" transform="translate(-160 -236)" fill="#0095c6"/>
</svg>
</template>
